// AUTOGENERATED FILE - DO NOT MODIFY!
// This file was generated by Djinni from 009_fatmap_api_debug_api.djinni
/** Corner of the screen to show the overlay */
export var DebugOverlayCorner;
(function (DebugOverlayCorner) {
    DebugOverlayCorner[DebugOverlayCorner["UPPERLEFT"] = 0] = "UPPERLEFT";
    DebugOverlayCorner[DebugOverlayCorner["UPPERRIGHT"] = 1] = "UPPERRIGHT";
    DebugOverlayCorner[DebugOverlayCorner["LOWERLEFT"] = 2] = "LOWERLEFT";
    DebugOverlayCorner[DebugOverlayCorner["LOWERRIGHT"] = 3] = "LOWERRIGHT";
})(DebugOverlayCorner || (DebugOverlayCorner = {}));
